/**
 * Route Pair Constants
 *
 * Single source of truth defining all valid fromPath → toPath navigation
 * pairs for the RouteReuseStrategy system.
 *
 * Caching (in-memory DOM reuse) and sessionStorage persistence are activated
 * ONLY when both the current URL and the navigated-to URL match a pair here.
 *
 * URL paths are relative to the hash fragment (after '#/') and use prefix
 * matching so that parameterised detail routes are covered automatically.
 *
 * To enable caching for a new list → detail flow, add one entry here.
 * No other files need to change.
 */
export interface RoutePair {
    /** The list/search page whose state should be preserved. Prefix matched. */
    fromPath: string;
    /** The detail/transactional page navigated to from the list. Prefix matched. */
    toPath: string;
}

export const ROUTE_REUSE_PAIRS: RoutePair[] = [
    // ── Products ────────────────────────────────────────────────────────────
    { fromPath: 'products/product-list', toPath: 'products/product-details' },
    { fromPath: 'products/product-list', toPath: 'products/product-edit' },

    // ── Sales – Orders ──────────────────────────────────────────────────────
    { fromPath: 'sales/all-orders', toPath: 'sales/allorder-detail' },

    // ── Sales – Returns ─────────────────────────────────────────────────────
    { fromPath: 'sales/all-returns', toPath: 'sales/allreturn-detail' },

    // ── Users – Shops ───────────────────────────────────────────────────────
    { fromPath: 'user/shoplist', toPath: 'user/userDetails' },

    // ── Users – Staff ───────────────────────────────────────────────────────
    { fromPath: 'user/list', toPath: 'user/staffDetails' },

    // ── Users – Customers ───────────────────────────────────────────────────
    { fromPath: 'user/userlist', toPath: 'user/userDetails' },

    // ── Service Near Job Dashboard ──────────────────────────────────────────
    { fromPath: 'servicenear/dashboard', toPath: 'servicenear/serviceDetails' },

    // ── Service Near – Product List ────────────────────────────────────────────
    { fromPath: 'servicenear/serviceProductList', toPath: 'products/product-details' },

    // ── Service Near – Superadmin (Companies) ──────────────────────────────────
    { fromPath: 'servicenear/superadmin', toPath: 'servicenear/sellersDetails' },

];
